import { toUSD } from 'helpers/NumberFormats';
import { pluralize } from 'helpers';
import css from 'styles/containers/returns/refundSummary.scss';

const makeTotals = items => {
  const totals = {
    subtotal: 0,
    promos: 0,
    tax: 0,
    total: 0
  };

  items.map(({ ourPrice, promoAmount, taxAmount }) => {
    totals.subtotal += ourPrice;
    totals.promos += promoAmount;
    totals.tax += taxAmount;
  });

  const { subtotal, tax, promos } = totals;
  totals.total = subtotal + tax + promos;

  return totals;
};

const RefundSummary = ({ items, boxNum, singleBox }) => {
  if (!items) {
    return '';
  }

  const { subtotal, promos, tax, total } = makeTotals(items);

  return (
    <div className={css.container}>
      <p>Refund Summary{!singleBox ? ` for Box ${boxNum}` : ''}</p>
      <div>
        <span>Subtotal ({items.length} {pluralize('item', items.length)}):</span>
        <span>{toUSD(subtotal)}</span>
      </div>

      <div>
        <span>Promotions Applied:</span>
        <span>({toUSD(Math.abs(promos))})</span>
      </div>

      <div>
        <span>Return Shipping:</span>
        <span>FREE</span>
      </div>

      <div>
        <span>Collected Tax:</span>
        <span>{toUSD(tax)}</span>
      </div>

      <div className={css.credit}>
        <span>*Credit Due:</span>
        <span>{toUSD(total)}</span>
      </div>
    </div>
  );
};

export default RefundSummary;
